import React, { Component } from 'react';
import CircleGraph from '../CircleGraph';
import moment from 'moment-timezone';
import { getProjectProgress, clampPercentage } from '../../../helpers/projectProgressUtil';

import './ProjectStatusGraphic.scss';

export default class ProjectStatusGraphic extends Component {

  createDateAndTime() {
    const { project } = this.props;
    if (!project || project.completed_at == null) return { createDate: '', createTime: '' };
    try {
      const timeZone = moment.tz.guess();
      const createDate = moment.tz(project.completed_at, timeZone).format('MM/DD/YY');
      const createTime = moment.tz(project.completed_at, timeZone).format('h:mm a z');
      return { createDate, createTime };
    } catch (e) {
      return { createDate: '', createTime: '' };
    }
  }

  createProjectStatus() {
    const { project, groupCompletionPercentage, anyInProgress } = this.props;
    let progressGraph;
    let projectStatus;

    // Branch 1: group/aggregate view (e.g. project groups) – status from clamped percentage
    if (groupCompletionPercentage !== undefined) {
      const clamped = clampPercentage(groupCompletionPercentage);
      const percent = clamped / 100;
      const graphColor = percent >= 1 ? '#5DB348' : percent > 0 ? '#f5a623' : '#9b9b9b';
      const stringPercent = `${clamped}%`;

      if (clamped === 0 && !anyInProgress) {
        projectStatus = 'Not Started';
      } else if (clamped >= 100) {
        projectStatus = 'Complete';
      } else {
        projectStatus = 'In Progress';
      }

      progressGraph = <div className="project-graph">
        <CircleGraph
          width={48}
          height={48}
          strokeWidth={3}
          position="relative"
          color={graphColor}
          percent={percent}
        />
        <div className="status">
          <div className="status-percent">
            {stringPercent}
          </div>
        </div>
      </div>;
      return { progressGraph, projectStatus, progressPercent: clamped };
    }

    // Branch 2: single project/build – status from getProjectProgress (steps preferred, then tasks)
    if (!project || typeof project !== 'object') {
      return { progressGraph: null, projectStatus: '', progressPercent: 0 };
    }

    const { percent, progressPercent } = getProjectProgress(project);

    // Derive status from progress so report column shows: 0% = Not Started, <100% = In Progress, 100% = Complete
    if (progressPercent >= 100) {
      projectStatus = 'Complete';
    } else if (progressPercent > 0) {
      projectStatus = 'In Progress';
    } else {
      projectStatus = 'Not Started';
    }

    if (project.archived_at) {
      projectStatus += '/Archived';
    }

    const graphColor = percent >= 1 ? '#5DB348' : percent > 0 ? '#f5a623' : '#9b9b9b';
    const stringPercent = progressPercent + '%';
    progressGraph = <div className="project-graph">
      <CircleGraph
        width={48}
        height={48}
        strokeWidth={3}
        position="relative"
        color={graphColor}
        percent={percent}
      />
      <div className="status">
        <div className="status-percent">
          {stringPercent}
        </div>
      </div>
    </div>;
    return { progressGraph, projectStatus, progressPercent };
  }

  render() {
    const { project } = this.props;
    const { progressGraph, projectStatus, progressPercent } = this.createProjectStatus();

    if (progressGraph == null && !projectStatus) {
      return null;
    }

    const style = projectStatus.includes('Archived') ? { overflow: 'initial', width: '0px' } : {};
    let completeDate;
    if (project && progressPercent >= 100 && project.completed_at) {
      completeDate = this.createDateAndTime().createDate;
    }

    return (
      <div className='cell-status'>
        {progressGraph}
        <div className='status-container'>
          <div className='cell-text' style={style}>{projectStatus}</div>
          <div className='completed-at'>{completeDate}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/graphics/ProjectStatusGraphic/index.js